import React, { Fragment } from 'react';
import ReactDOM from 'react-dom';
import BaseComponent from 'foundation/base-component';
import { Provider } from 'react-redux';
import TicketResaleBannerSection from './ticket-resale-banner-section';
import configureStore from '../../sso/store/configure-store';

class TicketResaleBannerComponent extends BaseComponent {
    constructor(...args) {
        super(...args);
        this.init();
    }

    init() {
        this.render();
    }

    onDestroy() {
        ReactDOM.unmountComponentAtNode(this.element);
    }

    render() {
        const store = configureStore();
        ReactDOM.render(
            <Fragment>
                <Provider store={store}>
                    <TicketResaleBannerSection
                        resaleTicketSettings={this.options.resaleTicketSettings}
                        ctaLoginLabel={this.options.ctaLoginLabel}
                        ctaLoginStyle={this.options.ctaLoginStyle}
                        ctaFirstLabel={this.options.ctaFirstLabel}
                        ctaFirstStyle={this.options.ctaFirstStyle}
                        ctaSecondLabel={this.options.ctaSecondLabel}
                        ctaSecondStyle={this.options.ctaSecondStyle}
                    />
                </Provider>
            </Fragment>,
            this.element
        );
    }
}

export default TicketResaleBannerComponent;
